import { render, staticRenderFns } from "./AddORDisableCounterparty.vue?vue&type=template&id=28f30782"
import script from "./AddORDisableCounterparty.vue?vue&type=script&lang=js"
export * from "./AddORDisableCounterparty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports